import axios from "axios";

export const loginUser = async ({ identifier, password }) => {
    const API_URL = process.env.REACT_APP_API_URL;
    try {
      const res = await axios.post(`${API_URL}/auth/local`, {
        identifier,
        password,
      });
      return res.data; // berisi jwt dan user info
    } catch (error) {
      throw error.response?.data?.error || { message: "Login gagal" };
    }
  };